import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'flare', 'Flare', [["path",{"d":"M12 3l3 6l6 3l-6 3l-3 6l-3 -6l-6 -3l6 -3l3 -6","key":"svg-0"}]]);